import { RootState } from "../store";

export const getCollectionYard = (state: RootState) => state.collectionYard.collectionYard;

export const getCollectionYardName = (state: RootState) => getCollectionYard(state).name;
export const getCollectionYardAddress = (state: RootState) => getCollectionYard(state).address;
export const getCollectionYardWasteTypeIds = (state: RootState) => getCollectionYard(state).wasteTypeIds;
export const getCollectionYardWasteTypeRates = (state: RootState) => getCollectionYard(state).wasteTypeRates;
export const getCollectionYardPaidBeforeVisitRequired = (state: RootState) =>
  getCollectionYard(state).paidBeforeVisitRequired;
export const getCollectionYardPaidVisitVerification = (state: RootState) =>
  getCollectionYard(state).paidVisitVerification;
